import {FAQ_ALL_CATEGORY} from '@/constants/help';
import HelpApi from './common';
import {FaqSearchListResponse} from './type';

export const helpApiBase = async (data: Record<string, unknown>) => {
  return HelpApi.post('/apihelp.php', data, {});
};

export const getFaqSearchList = ({
  searchWord,
  page,
  limit = 10,
}): Promise<FaqSearchListResponse> => {
  return helpApiBase({
    command: 'FaqSearchList',
    domainId: 'sooplive',
    searchQuestion: encodeURIComponent(searchWord),
    pageNo: page,
    rowsPerPage: limit,
    nodeId: FAQ_ALL_CATEGORY,
  });
};

export const evaluateFaq = ({
  faqId,
  isSatisfied,
}: {
  faqId: string;
  isSatisfied: boolean;
}) => {
  return HelpApi.post(
    '/api/set_faq_satisfaction.php',
    {
      kb_id: faqId,
      is_satisfied: isSatisfied ? 'Y' : 'N',
    },
    {},
  );
};
